/** Represents a Tab in the system, use TabTitlePipe to transform to string **/
export enum Tabs {
  Details = 'details-tab',
  Reviews = 'reviews-tab',
  Storyline = 'storyline-tab',
  Books = 'books-tab',
  Volumes = 'volumes-tab',
  Specials = 'specials-tab',
  Related = 'related-tab',
  General = 'general-tab',
  Folder = 'folder-tab',
  CoverImage = 'cover-tab',
  Advanced = 'advanced-tab',
  Tasks = 'tasks-tab',
  Recommendations = 'recommendations-tab',
  Info = 'info-tab',
  Tags = 'tags-tab',
  WebLinks = 'weblink-tab',
  People = 'people-tab',
  Metadata = 'metadata-tab',
  Series = 'series-tab',
  Account = 'account-tab',
  Preferences = 'preferences-tab',
  Theme = 'theme-tab',
  Devices = 'devices-tab',
  Stats = 'stats-tab',
  Scrobbling = 'scrobbling-tab',
  SmartFilters = 'smart-filters-tab',
  Annotations = 'annotations-tab',
  Overview = 'overview-tab',
  Management = 'management-tab',
  Activity = 'activity-tab',
  ExternalMetadataIds = 'external-ids-tab',
  Aliases = 'aliases-tab',
  Chapters = 'chapters-tab',

  Dashboard = 'dashboard-tab',
  SideNav = 'sidenav-tab',
  ExternalSources = 'external-sources-tab',

  ImageReader = "image-reader-tab",
  BookReader = "book-reader-tab",
  PdfReader = "pdf-reader-tab",

  BookmarkImageTab = "bookmark-image-tab",
  BookmarkTextTab = "bookmark-text-tab",

  KavitaPlus = 'kavita-plus-tab',
  Current = 'current-tab',
  Uploaded = 'uploaded-tab',
  Other = 'other-tab',

  All = 'all-tab',
  Scrobbles = 'scrobbles-tab',
  Failed = 'failed-tab',
  MyChanges = 'my-changes-tab',
  ScrobbleHolds = 'scrobble-holds-tab',

}
